import DataControl from "./DataControl.view";

export default DataControl;
